var _defs, _rect, _path, _ellipse, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotopstitch01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-221{fill:#fff;}.cls-220{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:5.7px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.16,
    y: 348.48,
    width: 39.61,
    height: 9.16,
    rx: 4.58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.45,148.79c0,7.57-6.13,188.35-13.7,188.35S201,156.36,201,148.79a13.71,13.71,0,1,1,27.41,0Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-221",
    cx: 214.75,
    cy: 165.52,
    rx: 4.57,
    ry: 15.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.16,
    y: 363.87,
    width: 260.3,
    height: 8.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132.98,
    y: 348.48,
    width: 39.61,
    height: 9.16,
    rx: 4.58
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 176.79,
    y: 348.48,
    width: 39.61,
    height: 9.16,
    rx: 4.58
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 220.6,
    y: 348.48,
    width: 39.61,
    height: 9.16,
    rx: 4.58
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 264.41,
    y: 348.48,
    width: 39.61,
    height: 9.16,
    rx: 4.58
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 308.23,
    y: 348.48,
    width: 39.61,
    height: 9.16,
    rx: 4.58
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M125.59,210.83c6.33-5.84,49.17-44.59,88-40.73,4.85.48,14,1.39,22.81,7.6,14.42,10.19,15.59,26,20.64,35.85,7.35,14.34,29.15,28.1,91.78,26.61"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26.34,
    y: 247.35,
    width: 380.11,
    height: 9.48,
    transform: "translate(206.44 -79.99) rotate(38.93)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.34,
    y: 247.35,
    width: 380.11,
    height: 9.48,
    transform: "translate(543.14 312.24) rotate(141.07)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotopstitch01);
export default __webpack_public_path__ + "static/media/NO TOP STITCH-01.042cf0a1d041e6d31ad5e21c093281a7.svg";
export { ForwardRef as ReactComponent };